// extracted by mini-css-extract-plugin
module.exports = {"buttonsContainer":"OnGoingPaymentBox_buttonsContainer__RE07x","resendInfoText":"OnGoingPaymentBox_resendInfoText__1P94H"};